import { SearchFields, Statuses, StatusesInfo } from '~/utils/types/contact';

export const DEFAULT_PAGE = 1;
export const DEFAULT_SORT_DIRECTION = 'ASC';

export const STATUS_TABS_CONTACT_DETAILS: Array<string> = [
  'basicInfo',
  'notes',
  'tasks',
  'files',
  'jobs',
  'activities',
];

export const STATUSES: Statuses = ['progress', 'hold', 'completed'];

export const STATUS_DEFAULT = 'progress';

export const STATUSES_INFO: StatusesInfo = ['progress', 'completed', 'hold', 'new'];

export const STATUS_DEFAULT_INFO = 'new';

export const SEARCH_FIELDS: SearchFields = ['name', 'createdBy', 'status', 'deadline'];
